import React from 'react';
import { useLocation } from 'react-router-dom';

function scrollToHash(hash: string) {
  const id = hash.replace('#', '');
  if (!id) return false;
  const el = document.getElementById(id);
  if (!el) return false;
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return true;
}

export function ScrollManager() {
  const location = useLocation();

  React.useEffect(() => {
    // Hash navigation (anchor links)
    if (location.hash) {
      // give layout a tick to render
      const t = window.setTimeout(() => {
        const ok = scrollToHash(location.hash);
        if (!ok) window.scrollTo({ top: 0, behavior: 'auto' });
      }, 50);
      return () => window.clearTimeout(t);
    }

    // Route navigation
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [location.pathname, location.hash]);

  return null;
}


